import React from "react";

export function Skeleton({ className = "" }) {
  return <div className={`k-skeleton ${className}`} />;
}

export function CardSkeleton() {
  return (
    <div className="k-glass rounded-2xl p-5 space-y-3" data-testid="skeleton-card">
      <Skeleton className="h-3 w-20" />
      <Skeleton className="h-8 w-32" />
      <Skeleton className="h-10 w-full" />
    </div>
  );
}

export function RowSkeleton({ cols = 5 }) {
  return (
    <div className="flex gap-3 p-3">
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} className="h-4 flex-1" />
      ))}
    </div>
  );
}

export function EmptyState({ title, description, action, icon: Icon }) {
  return (
    <div className="k-glass rounded-2xl p-10 text-center" data-testid="empty-state">
      <div className="w-16 h-16 mx-auto mb-4 rounded-2xl flex items-center justify-center bg-[#534AB7]/10 text-[#534AB7]">
        {Icon ? <Icon size={28} /> : <span>·</span>}
      </div>
      <h3 className="text-lg font-semibold">{title}</h3>
      {description && <p className="text-sm text-muted-foreground mt-1 max-w-md mx-auto">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
